import React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { debounce } from 'throttle-debounce';
import styled from 'styled-components';

import { ContentSet } from 'components/Shared/Scaffolding';
import Panel, { PanelTitle } from 'components/Shared/Panel';
import { TextButton } from 'components/Shared/Buttons';
import TabGroup from 'components/Shared/Tabs/TabGroup';
import SearchTab from 'components/StyleSettings/SearchTab';
import {
    getPreviewStyle,
    setPreviewStyleAction,
    clearPreviewStyleAction,
    setTabAction,
    saveFieldsAction,
} from 'modules/navigation/stylePanel';
import { setStyleAction, getStyle } from 'modules/style';
import { SCAFFOLDING } from 'theme';
import MODAL from 'components/Shared/Modals';
import { showModal } from 'modules/modal';

const StyledForm = styled.form`
    height: 100%;
`;

const ScrollWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`;

const ScrollContent = styled(ContentSet)`
    flex: 1 1 auto;
    overflow: auto;
`;

const ScrollFooter = styled.div`
    flex: 0 0 auto;
    padding: ${SCAFFOLDING.GUTTER_FACTOR(0.5)} ${SCAFFOLDING.GUTTER};
    border-top: 1px solid ${SCAFFOLDING.BORDER_COLOR};
`;

class PanelContent extends React.Component {
    componentDidMount() {
        this.props.handleOnMount();
    }

    render() {
        const { tabs, handleSubmit, selectedTab, handleTabChange, scrollToTop } = this.props;
        return (
            <StyledForm onSubmit={handleSubmit}>
                <ScrollWrapper>
                    <ScrollContent
                        spacing={SCAFFOLDING.GUTTER}
                        padding={SCAFFOLDING.GUTTER}
                        ref={(el) => {
                            this.styleScrollContent = el;
                        }}
                    >
                        <PanelTitle>Choose a Map Style</PanelTitle>
                        <TabGroup
                            tabs={tabs.map((tab) => tab.name)}
                            selected={selectedTab}
                            onTabClick={handleTabChange}
                        >
                            {tabs.map((tab, index) => (
                                <SearchTab
                                    key={index}
                                    tab={tab}
                                    tabIndex={index}
                                    scrollToTop={() => scrollToTop(this.styleScrollContent)}
                                />
                            ))}
                        </TabGroup>
                    </ScrollContent>
                    <ScrollFooter>
                        <TextButton block primary type="submit">
                            Apply Style
                        </TextButton>
                    </ScrollFooter>
                </ScrollWrapper>
            </StyledForm>
        );
    }
}

// eslint-disable-next-line react/no-multi-comp
class StylePanel extends React.Component {
    onClose = () => {
        const { mapStyle, previewStyle, dispatch, onClose } = this.props;
        if (!previewStyle || mapStyle.id !== previewStyle.id) {
            dispatch(
                showModal(MODAL.CONFIRM_PANEL_CLOSE, {
                    dispatches: [clearPreviewStyleAction()],
                })
            );
        } else {
            dispatch(clearPreviewStyleAction());
            onClose();
        }
    };

    render() {
        const { open, ...otherProps } = this.props;
        return (
            <Panel open={open} onClose={this.onClose}>
                <PanelContent {...otherProps} />
            </Panel>
        );
    }
}

const mapStateToProps = (state) => ({
    mapStyle: getStyle(state, true),
    previewStyle: getPreviewStyle(state),
    selectedTab: state.navigation.stylePanel.tab,
    tabs: state.navigation.stylePanel.tabs,
    initialValues: {
        tabs: state.navigation.stylePanel.tabs.map((tab) => ({
            ...tab.fields,
        })),
    },
});

const mapDispatchToProps = (dispatch) => ({
    onSubmit: (values, dispatch) => {
        dispatch(saveFieldsAction(values.tabs));
    },
    onSubmitSuccess: (result, dispatch, props) => {
        dispatch(setStyleAction(props.previewStyle));
        dispatch(clearPreviewStyleAction());
        props.onClose();
    },
    handleTabChange: (tab, index) => {
        dispatch(setTabAction(index));
    },
    onChange: debounce(250, (values, dispatch) => {
        dispatch(saveFieldsAction(values.tabs));
    }),
    handleOnMount: (style) => {
        dispatch(setPreviewStyleAction(style));
    },
});

const mergeProps = (stateProps, dispatchProps, ownProps) =>
    Object.assign({}, ownProps, stateProps, dispatchProps, {
        handleOnMount: () => dispatchProps.handleOnMount(stateProps.mapStyle),
    });

StylePanel = reduxForm({
    form: 'style-panel-form',
})(StylePanel);

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(StylePanel);
